










































import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { IJobPosting, ISearchParams } from '@app/componentlib/common/types/JobSearchTypes'
import { IRegion } from '@app/componentlib/common/types/LocationTypes'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<JobSearchButtons>({
  props: {
    filterIsActive: Boolean,
    currentInput: String,
    locationInput: String,
    canSaveSearch: Boolean,
    mobileFiltersIsOpen: Boolean,
    selectedJobPosting: Object
  }
})

export default class JobSearchButtons extends Vue {
  /**
   * Props variables
   */
  filterIsActive: boolean | undefined
  currentInput: string | undefined
  locationInput: string | undefined
  canSaveSearch: boolean | undefined
  mobileFiltersIsOpen: boolean | undefined
  selectedJobPosting: IJobPosting | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get searchParams (): ISearchParams | undefined {
    return JobSearchModule.searchParams
  }

  get getFilterStrings (): string[] {
    return this.searchParams?.FilterStrings!
  }

  get locations (): IRegion[] {
    return LocationModule.locations
  }

  get hasActiveFilters (): Boolean {
    if (this.searchParams === undefined)
      return false

    return this.filterIsActive || this.searchParams.IndustryFilter.length > 0 || this.searchParams.CareerFilter.length > 0 || this.searchParams.JobCategoryFilter.length > 0
  }

  get checkClearSearch (): Boolean {
    if (this.searchParams === undefined)
      return false

    return this.locationInput === '' && this.currentInput === '' && this.locations.length < 1 && this.getFilterStrings.length < 1 && this.searchParams.IndustryFilter.length < 1 && this.searchParams.CareerFilter.length < 1 && this.searchParams.JobCategoryFilter.length < 1
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  /**
   * Methods
   */
  startSearch() {
    this.$emit('startSearch')
  }

  changeFilterIsActive() {
    this.$emit('changeFilterIsActive')
  }

  clearSearch() {
    this.$emit('clearSearch')
  }

  openSaveSearchModal() {
    this.$emit('openSaveSearchModal')
  }

  goToPage(url?: string) {
    this.$emit('goToPage', url)
  }
}
